import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { SharedUser } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<SharedUser>>>;

const addUserToGroup = (
    id: string,
    users: Array<string>,
    role: string,
    message?: string,
): ReturnType => {
    return Request.post(`/groups/${id}/users`, {
        users,
        role,
        message,
    });
};

export default addUserToGroup;
